import React ,{Component } from 'react';
import NewMessage from '../views/newmessage';
import ShowMessage from '../views/showmessage';
import { messageActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";

class MessageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isShow:false
         }
        this.submit = this.submit.bind(this);
    }
    
    submit(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;
        //console.log('data',data);

        dispatch(messageActions.add(data));
        
        //console.log(data);
    
    }

    componentDidMount(){
       
        const { dispatch,match } = this.props;   
        dispatch(messageActions.getrecieverlist());

        if(match.path=='/message/new')
        {
            this.setState({
                isShow:false
            })

        }else{


            this.setState({
                isShow:true
            })

            const {id}=this.props.match.params;
            dispatch(messageActions.get(id));



        }



    //    const {patientId}=this.props.match.params;
    //    // console.log('Props',this.props);
    //    const { dispatch } = this.props;   
       
    //      if (patientId) {

    //         let id = patientId;
             
    //         dispatch(messageActions.get(id));
            
           
        
    //     } 
    }

    render() { 

        const { type,obj,error } = this.props;
        console.log('error',error)
        //console.log('TYPE',type);
        if(type==objConstants.ADD_SUCCESS)
        {
            //console.log('Added successfully');
            history.push('/message/inbox')
        }
        if(type==objConstants.UPDATE_SUCCESS)
        {
           // console.log('Updated successfully');
            history.push('/message/inbox')
        }
        const {isShow}=this.state;

        if(isShow==false)
        {
            return (
            
                <NewMessage submitHandler={this.submit}  recieverList={this.props.items && this.props.items.RecieverList}  {...this.props}  ref="child" />
            );
        }else
        {
            return (
                <ShowMessage model={obj && obj.Message}  {...this.props}  ref="child" />
            );
        }
        
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
   
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error      
    };
} 

export default withRouter(connect(mapStateToProps)(MessageContainer));